export interface Input {
  value?: string;
  min?: number;
  max?: number;
  step?: number;
  unit?: string;
  label?: string;
  "on-change"?: ({ value }: { value: string }) => void;
}

export default class extends Marko.Component<Input> {
  handleSliderChange(event: Event) {
    const target = event.target as HTMLInputElement;
    this.emit("change", { value: target.value });
  }

  handleIncrement() {
    const { value, min = 1, max = 200, step = 1 } = this.input;
    const numericValue = value ? parseInt(value, 10) : min;
    const newValue = Math.min(numericValue + step, max);
    this.emit("change", { value: String(newValue) });
  }

  handleDecrement() {
    const { value, min = 1, step = 1 } = this.input;
    const numericValue = value ? parseInt(value, 10) : min;
    const newValue = Math.max(numericValue - step, min);
    this.emit("change", { value: String(newValue) });
  }
}
